import React from 'react'

import Provider from './src/provider'

export const wrapRootElement = ({ element }) => {
  return <Provider>{element}</Provider>
}
